export default [
    {
        path: '/heishop/cpl',
        name: 'heishop-cpl',
        meta: {
            layout: 'session'
        },
        component: () => import('VIEWS/heishop/Cpl.vue')
    },

]